// ── „ההתחברות פגה" (UX X1, אלי 30/10/2026) ───────────────────────────────────
//
// מנהל פרויקט, סמנכ״ל וקניין נחתו באמצע עבודה על „כניסה למערכת" בלבד — בלי
// לדעת שהסשן פג ובלי לחזור למה שעשו. השרת עונה 401 גם למי שמעולם לא נכנס,
// ולכן הדפדפן זוכר סימן אחד: „היה כאן סשן ולא יצאו ממנו". יציאה מכוונת מוחקת
// אותו — אחריה מסך הכניסה הרגיל, בלי הודעה.
//
// ⚠ localStorage יכול לזרוק (חלון פרטי, אחסון חסום) — כל גישה עטופה.

const KEY = 'edal.hadSession';

export function markSignedIn(): void {
  try { localStorage.setItem(KEY, '1'); } catch { /* אחסון חסום — בלי הודעה, לא שבירה */ }
}

export function markSignedOut(): void {
  try { localStorage.removeItem(KEY); } catch { /* ראה למעלה */ }
}

export function hadSession(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}
